interface gradiantSkeltonTypes {
  width?: string
  height?: string
  className?: string
  children?: React.ReactNode
}

const GradiantSkelton = ({
  width,
  height,
  className,
}: gradiantSkeltonTypes) => {
  return (
    <div
      data-testid='skeleton-line'
      className={`${width} ${height} animate-pulse relative overflow-hidden  rounded-radius-full bg-gradient-to-l from-tertiary to-secondary ${className}`}
    >
      <div
        className='absolute inset-0 bg-gradient-to-1 from-tertiary to-secondary
          w-[150%] h-full animate-shimmer'
      ></div>
    </div>
  )
}

export default GradiantSkelton
